import type { IAccessLink } from '../../../../../../../../models/access-link.model';
import { DateHelper } from '../../../../../../../../helpers/date.helper';
import TravelTo from '../TravelTo';
import { TransportMode } from '../../../../../../../../models/transport-mode.enum';

function AccessLink({ departureAccessLink = undefined, arrivalAccessLink = undefined }: { departureAccessLink?: IAccessLink; arrivalAccessLink?: IAccessLink }) {
  const transportMode = departureAccessLink?.transportMode || arrivalAccessLink?.transportMode || TransportMode.unknown;
  const originPlannedTime = departureAccessLink?.origin?.plannedTime || arrivalAccessLink?.origin?.plannedTime;
  const destinationPlannedTime = departureAccessLink?.destination?.plannedTime || arrivalAccessLink?.destination?.plannedTime;
  const originEstimatedTime = departureAccessLink?.origin?.estimatedTime || arrivalAccessLink?.origin?.estimatedTime;
  const destinationEstimatedTime = departureAccessLink?.destination?.estimatedTime || arrivalAccessLink?.destination?.estimatedTime;
  const distanceInMeters = departureAccessLink?.distanceInMeters || arrivalAccessLink?.distanceInMeters;

  return (
    <div className="access-link">
      <TravelTo
        transportMode={transportMode}
        durationInMinutes={
          originPlannedTime && destinationPlannedTime ? DateHelper.getDurationFromDateStrings(originEstimatedTime || originPlannedTime, destinationEstimatedTime || destinationPlannedTime) : undefined
        }
        distanceInMeters={distanceInMeters}
      ></TravelTo>
    </div>
  );
}

export default AccessLink;
